import { Component, Input, OnInit } from '@angular/core';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import { UserDetailsModalComponent } from '../user-details-modal/user-details-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'username-display',
  templateUrl: './username-display.html',
})
export class UsernameDisplayComponent implements OnInit {

  /** The login. Also the key the details lookup is done by, so it must stay the login. */
  @Input() userName: string;

  /** Optional friendlier label to show instead of the login. Falls back to userName. */
  @Input() displayName: string;

  constructor(private workOrderService: SiteWorkOrdersService,
    private modalService: NgbModal,
    private notificationService: NotificationService,
    ) { }

  ngOnInit() {
  }

  public openModalUserDetails(user) {
    this.workOrderService.getUserDetails(user).subscribe((data) => {
      if (data) {
        const modalRef = this.modalService.open(UserDetailsModalComponent, { centered: true });
        modalRef.componentInstance.userDetails = data;
      } else {
        this.notificationService.notify('danger', 'No user information available.');
      }
    }, (error) => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving user informations.');
    });
  }
}
